"use strict";

class CbiAndRbiCountriesController {

    constructor($parse, $timeout, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfirmationService, SSConfigService, SSCountryListService) {
        const self = this;

        self.$parse = $parse;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSConfigService = SSConfigService;

        // WEB-4383: exposed on the controller because modal_country_list_refresh
        // binds straight to ctrl.SSCountryListService.
        self.SSCountryListService = SSCountryListService;

        self.data = SHOWSUITE.data;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }

        self.selectedCbiRbiCountires = [];
    }

    init() {
        const self = this;

        self.countries = self.SSConfigService.getCountries();
        if(self.countries && self.countries.length){ // Convert Country name to urf-8 string
            self.countries = self.countries.map(c => {
                c.name = self.SSUtilService.convertUnicodeToUtf8String(c.name);
                return c;
            })
        }

        self.non_cbi_rbi_countries = self.SSConfigService.getCountries();
        self.$timeout(function () {
            $("select.eoi-select").niceSelect();
        });

        self.getDeveloperSettings();
    }

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings/by-name?name=cbi_rbi_countries';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){
                // Get CBI and RBI Countries Settings
                self.cbi_rbi_countries_settings = self.getSetting(response.data.developer_settings, 'cbi_rbi_countries');
                if(self.cbi_rbi_countries_settings
                        && self.cbi_rbi_countries_settings.value
                        && self.cbi_rbi_countries_settings.value.length){
                    self.cbi_rbi_countries = self.cbi_rbi_countries_settings.value;
                    self.haveCbiRbiCountries = true;
                    // If cbi_rbi countries exist, update non-cbi_rbi countries list
                    self.refreshNonCbiRbiCountries();
                }
            }
        });
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){ return null; }

        let setting = {};
        try{
            setting = settings.find(x => x.name == setting_name);
            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                } else {
                    setting.value = setting.value;
                }
            }
        }
        catch(ex){ console.error(ex); }

        return setting;
    }

    /**
     * Re-derive the "add a country" dropdown from the current CBI/RBI list.
     *
     * Every mutation of self.cbi_rbi_countries has to go through here: the
     * dropdown must not offer a country that is already on the list, and Nice
     * Select renders its own markup once, so it needs an explicit 'update' after
     * the options change or the user keeps seeing the previous set.
     *
     * @returns {void}
     */
    refreshNonCbiRbiCountries() {
        const self = this;

        let listed = self.cbi_rbi_countries || [];

        self.non_cbi_rbi_countries = (self.countries || [])
            .filter(c => listed.indexOf(c.country_code) === -1);

        self.$timeout(function () {
            $("select.eoi-select").niceSelect('update');
        });
    }

    addCbiRbiCountry() {
        const self = this;

        if (!self.selectedCountryForCbiRbiList) { return false; }

        self.cbi_rbi_countries = self.cbi_rbi_countries || [];
        if (self.cbi_rbi_countries.indexOf(self.selectedCountryForCbiRbiList) < 0) {
            self.cbi_rbi_countries.push(self.selectedCountryForCbiRbiList);

            self.refreshNonCbiRbiCountries();
        }
        self.selectedCountryForCbiRbiList = "";
    }

    removeCbiRbiCountry(country_code){
        const self = this;

        self.cbi_rbi_countries = self.cbi_rbi_countries || [];
        if (country_code && self.cbi_rbi_countries.indexOf(country_code) > -1) {
            self.cbi_rbi_countries.splice(self.cbi_rbi_countries.indexOf(country_code), 1);

            self.refreshNonCbiRbiCountries();
        }
    }

    _saveCbiRbiCountriesSettings(){
        const self = this;

        let cbi_rbi_countries = self.cbi_rbi_countries ? self.cbi_rbi_countries : [];

        let url = 'sec/developer/settings';
        let params = {
            name: "cbi_rbi_countries",
            value: JSON.stringify(cbi_rbi_countries)
        }

        let handleResponse = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.isEditCbiRbiCountries = false;
            self.haveCbiRbiCountries = false;
            self.SSAlertService.success('Success!', 'CBI/RBI Countries settings updated successfully.');
            self.getDeveloperSettings();
        };

        loading(true);
        if (self.cbi_rbi_countries_settings && self.cbi_rbi_countries_settings.id) {
            url += '/' + self.cbi_rbi_countries_settings.id;
            self.SSHttpService.putAPIRequest(url, params).then(handleResponse);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(handleResponse);
        }
    }

    getCountryDisplayName(country_code){
        self = this;

        let countryDisplayName = "";
        if(self.countries
                && self.countries.length
                && self.countries.find(c => c.country_code === country_code)){
            countryDisplayName = self.countries.find(c => c.country_code === country_code).name;
        }
        return countryDisplayName;
    }

    onEditCbiRbiCountriesSettings(){
        const self = this;

        if (self.cbi_rbi_countries_settings && self.cbi_rbi_countries_settings.value) {
            self.cbi_rbi_countries = angular.copy(self.cbi_rbi_countries_settings.value);
        }

        self.isEditCbiRbiCountries = true;
    }

    onCancelCbiRbiCountriesSettings(){
        const self = this;

        self.cbi_rbi_countries = [];
        if (self.cbi_rbi_countries_settings && self.cbi_rbi_countries_settings.value) {
            self.cbi_rbi_countries = angular.copy(self.cbi_rbi_countries_settings.value);
        }

        if(!self.cbi_rbi_countries.length){
            self.haveCbiRbiCountries = false;
        }
        self.isEditCbiRbiCountries = false;
    }

    /**
     * Enable/disable toggle for the CBI/RBI list.
     *
     * ng-change fires after ng-model has already flipped, so haveCbiRbiCountries
     * holds the value the user just asked for. It is put back until they confirm,
     * and only then applied.
     *
     * @returns {void}
     */
    onEnableDisableCbiRbi(){
        const self = this;

        if(self.haveCbiRbiCountries){
            self.haveCbiRbiCountries = false;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to enable CBI/RBI countries? \nThe latest published list of CBI/RBI countries will be populated. You may customised as needed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function () {
                    // WEB-4383: seeded from the server's canonical list rather than a
                    // copy of the codes kept here. The portal used to hold its own
                    // hardcoded vintage, which is how the three clients drifted apart
                    // and why a project could never be moved onto a newer publication.
                    // The toggle stays off if the fetch fails, so the user is never
                    // left with an "enabled" list the server did not supply.
                    self.SSCountryListService.getLatestCodes(
                        self.SSCountryListService.LIST_TYPE_CBI_RBI,
                        function (country_codes) {
                            self.haveCbiRbiCountries = true;
                            self.cbi_rbi_countries = country_codes;
                            self.refreshNonCbiRbiCountries();
                        }
                    );
                }
            );
        } else {
            self.haveCbiRbiCountries = true;
            self.SSConfirmationService.getConfirmed(
                'Confirmation!',
                'Are you sure you want to proceed to disable CBI/RBI countries? \nThe list will be removed.',
                self.SSConfirmationService.TYPE_YES_NO,
                function (answer) {
                    self.haveCbiRbiCountries = false;
                    self.cbi_rbi_countries = [];
                    self._saveCbiRbiCountriesSettings();
                }
            );
        }
    }

    /**
     * WEB-4383 — "Fetch Latest": bring this project back onto the published CBI/RBI list.
     *
     * Two steps, both handled by SSCountryListService: a read-only preview that
     * opens the overwrite-warning popup, and, only if the user confirms there, the
     * write. Nothing changes if they cancel.
     *
     * @returns {void}
     */
    onFetchLatestCbiRbiCountries(){
        const self = this;

        self.SSCountryListService.fetchLatest(
            self.SSCountryListService.LIST_TYPE_CBI_RBI,
            function () {
                // Re-read rather than patching the local copy: the refresh wrote the
                // list server-side, and getDeveloperSettings() is what re-derives the
                // enabled flag and the "updated by / updated at" line from the saved
                // row. Cleared first because that method only switches the flag back
                // on when the reloaded list is non-empty.
                self.isEditCbiRbiCountries = false;
                self.haveCbiRbiCountries = false;
                self.cbi_rbi_countries = [];
                self.getDeveloperSettings();
            }
        );
    }

}

CbiAndRbiCountriesController.$inject = [
    '$parse',
    '$timeout',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSUserService',
    'SSConfirmationService',
    'SSConfigService',
    'SSCountryListService'];
app.controller('CbiAndRbiCountriesController', CbiAndRbiCountriesController);
